export default [
  {
    path: '/main/os-finished',
    meta: {
      tag: 'list_os_finished',
      name: 'Ordens de serviço - Finalizadas',
      breadcrumb: 'Ordens de serviço - Finalizadas'
    },
    component: () => import(/* webpackChunkName: "os-list-finished" */ '@/views/main/os-finished/Index.vue'),
    children: [
      {
        path: '',
        name: 'listosfinished',
        meta: {
          tag: 'list_os_finished',
          name: 'Ordens de serviço - Finalizadas',
          menu: 'osfinished'
        },
        component: () => import(/* webpackChunkName: "os-list-finished" */ '@/views/main/os-finished/List.vue')
      }
    ]
  }
]
